import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Eye, LogOut, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export const ViewAsBanner = () => {
  const { user, exitViewAs } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  if (!user?.impersonated_by) return null;

  const exit = async () => {
    setBusy(true);
    try { await exitViewAs(); navigate("/admin"); toast.success("Back to your admin account"); }
    catch (err) { toast.error(err.response?.data?.detail || "Couldn't exit — please log in again"); }
    finally { setBusy(false); }
  };

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[60] w-[calc(100%-2rem)] max-w-2xl bg-amber-400 text-slate-900 rounded-xl shadow-2xl px-4 py-3 flex items-center gap-3" data-testid="view-as-banner">
      <Eye className="w-5 h-5 shrink-0" />
      <p className="text-sm flex-1 min-w-0">
        Viewing as <b className="break-all">{user.name || user.email}</b> <span className="uppercase text-[10px] font-bold bg-slate-900/10 px-1.5 py-0.5 rounded">{user.role}</span>
        <span className="hidden sm:inline text-slate-700"> · changes you make are saved and logged</span>
      </p>
      <button onClick={exit} disabled={busy} className="bg-slate-900 hover:bg-slate-700 text-white text-sm font-bold px-3 py-1.5 rounded-lg flex items-center gap-1.5 shrink-0 disabled:opacity-50" data-testid="view-as-exit-btn">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <LogOut className="w-4 h-4" />}Exit
      </button>
    </div>
  );
};
